const USER_INFO = 'user_info'
const TOKEN = 'token'
const LANGUAGE = 'language'

export default {
  USER_INFO,
  TOKEN,
  LANGUAGE,
}
